import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import en from 'vee-validate/dist/locale/en'
import VeeValidate, { Validator } from 'vee-validate'
import BootstrapVue from 'bootstrap-vue'
import { domain, toLower, count, prettyDate, pluralize, capitalize, currency, translate, dateFormat2, dateFormat, toUpper, orderDate, orderTitle, country, percentage } from './filters'

Vue.filter('count', count)
Vue.filter('domain', domain)
Vue.filter('prettyDate', prettyDate)
Vue.filter('pluralize', pluralize)
Vue.filter('capitalize', capitalize)
Vue.filter('currency', currency)
Vue.filter('translate', translate)
Vue.filter('dateFormat', dateFormat)
Vue.filter('dateFormat2', dateFormat2)
Vue.filter('toUpper', toUpper)
Vue.filter('orderDate', orderDate)
Vue.filter('orderTitle', orderTitle)
Vue.filter('country', country)
Vue.filter('percentage', percentage)
Vue.filter('toLower', toLower)
Vue.use(BootstrapVue)
Vue.use(VeeValidate, {events: 'change|blur'})
Validator.localize('en', en);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
